module.exports = __webpack_public_path__ + "img/hgz.25dcfea8.png";